import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "row"
}
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 2,
  class: "row alert alert-info mx-1 px-0"
}
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "d-grid gap-2 d-md-flex justify-content-md-end mt-4" }
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_spinner = _resolveComponent("loading-spinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isEvaluating)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "row" }, [
            _createElementVNode("div", { class: "col" }, [
              _createElementVNode("p", null, "Evaluating...")
            ])
          ], -1)),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "row" }, [
            _createElementVNode("div", { class: "col text-center" }, [
              _createElementVNode("div", {
                class: "spinner-border",
                role: "status"
              }, [
                _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
              ])
            ])
          ], -1))
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.isViable)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("p", null, " It looks like your plan would still be expected to work if you used " + _toDisplayString(_ctx.canBuyGuaranteedIncomeResponse.percentAllocatedFromPots) + "% of your pots to buy some guaranteed income, giving you less risk of running out of money in retirement. ", 1),
                  _cache[4] || (_cache[4] = _createElementVNode("p", null, " You can investigate this further in our Dashboard, Track and Help page. ", -1)),
                  _cache[5] || (_cache[5] = _createElementVNode("p", null, "Do you want to include this in your plan?", -1))
                ], 64))
              : (_openBlock(), _createElementBlock("p", _hoisted_3, " Using " + _toDisplayString(_ctx.canBuyGuaranteedIncomeResponse.percentAllocatedFromPots) + "% of your non protected pension pots to buy some guaranteed income at retirement will lead to shortfalls. You can investigate different percentages in our Dashboard, Track and Help page. ", 1))
          ])
        ])),
    (_ctx.hasError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", null, _toDisplayString(_ctx.errorMessage), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.showYesButton)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            disabled: !_ctx.yesBtnEnabled,
            class: "btn px-5 btn-secondary",
            "aria-label": "Yes",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onYesClicked && _ctx.onYesClicked(...args)))
          }, [
            _cache[6] || (_cache[6] = _createTextVNode(" Yes ")),
            _createVNode(_component_loading_spinner, { visible: _ctx.implementingSolution }, null, 8, ["visible"])
          ], 8, _hoisted_7))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "button",
        class: "btn px-5 btn-secondary",
        "aria-label": "No",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('check-finished', false)))
      }, _toDisplayString(_ctx.noButtonText), 1)
    ])
  ], 64))
}